import client from './client';

export interface CelebrationTab {
  id: string;
  label: string;
  content: string;
}

export const getCelebrationInfo = async (): Promise<CelebrationTab[]> => {
  const response = await client.get('/celebration/info');
  return response.data.data;
};
